import {
  createPackage,
  createPackageCB,
  createPackageSP,
  createNoInsurancePackage,
  createMailboxPackage,
  createDigitalStamp,
} from "./myParcel";

// Landcode normalisatie (voor dropdowns of validatie in de UI)
export const normalizeCountryCode = (code) => {
  if (!code) return "";
  const upper = code.toUpperCase();
  if (upper === "D") return "DE";
  if (upper === "B") return "BE";
  return upper;
};

const productToCarrier = {
  "Startpakket": 4,
  "Chromebook": 4,
  "Telefoon": 4,
  "Oplader Chromebook": 4,
  "Simkaart": 1,
  "OTP Token": 1,
  "Oplader Telefoon": 1,
  "Bumper 1 Stuks": 1,
  "Bumpers 2 Stuks": 1,
  "Bumpers 4 Stuks": 1,
  "Bumpers": 4,
  "Chromebook sleeve": 4,
};

// NIEUWE FUNCTIE: Haalt alleen de Carrier ID op
export const getCarrierIdByProduct = (selectedProduct) => {
    return productToCarrier[selectedProduct] || 1; // 1 als fallback
};

// Voor het tonen van pakketopties in de frontend (optioneel)
const productToFunction = {
  "Startpakket": createPackage,
  "Chromebook": createPackageCB,
  "Telefoon": createPackageSP,
  "Simkaart": createDigitalStamp,
  "OTP Token": createDigitalStamp,
  "Oplader Telefoon": createDigitalStamp,
  "Oplader Chromebook": createNoInsurancePackage,
  "Bumper 1 Stuks": createDigitalStamp,
  "Bumpers 2 Stuks": createDigitalStamp,
  "Bumpers 4 Stuks": createDigitalStamp,
  "Bumpers": createNoInsurancePackage,
  "Chromebook sleeve": createMailboxPackage,
};

// GECORRIGEERDE handleProductChange: Retourneert NU ALLEEN de pakketopties
export const handleProductChange = (selectedProduct, label_description) => {
  const createFn = productToFunction[selectedProduct];
  if (!createFn) return null;

  // Haalt nu alleen de options op, GEEN 'carrier' property
  return createFn(label_description);
};